import { createContext } from 'react';
import { IItemForGetShortInfo, TLanguageIDs, ICreateVideoCategory, IVideoCategoryTranslation } from 'types';

export type TCreateVideoCategoryVisibleForm = 'mainForm' | 'translations';
export type TTypeOfCreateVideoCategoryModalWindow =
	| null
	| 'toConfirmFieldsClearing'
	| 'toConfirmSubmit'
	| 'success'
	| 'error'
	| 'someTranslationIsEmpty';

export interface ICreateVideoCategoryState {
	visibleForm: TCreateVideoCategoryVisibleForm;
	name: string;
	fetchedLanguages: IItemForGetShortInfo[];
	IDsSelectedLanguages: TLanguageIDs[];
	dataForSubmit: ICreateVideoCategory | null;
	typeOfModalWindow: TTypeOfCreateVideoCategoryModalWindow;
	selectedTranslationTab: TLanguageIDs | null;
	translations: IVideoCategoryTranslation[];
}

export const createVideoCategoryInitialState: ICreateVideoCategoryState = {
	visibleForm: 'mainForm',
	name: '',
	fetchedLanguages: [],
	IDsSelectedLanguages: [],
	dataForSubmit: null,
	typeOfModalWindow: null,
	selectedTranslationTab: null,
	translations: [],
};

export interface ICreateVideoCategoryContext extends ICreateVideoCategoryState {
	changeVisibleForm(value: TCreateVideoCategoryVisibleForm): void;
	changeName(value: string): void;
	setFetchedLanguages(value: IItemForGetShortInfo[]): void;
	setIDsLanguages(value: TLanguageIDs[]): void;
	setDataForSubmit(data: ICreateVideoCategory | null): void;
	changeTypeOfModalWindow(value: TTypeOfCreateVideoCategoryModalWindow): void;
	setTranslationTab(value: TLanguageIDs | null): void;
	changeNameTranslation(languageId: TLanguageIDs, value: string): void;
	resetFields(): void;
}

export const CreateVideoCategoryContext = createContext<ICreateVideoCategoryContext>({
	changeVisibleForm: () => undefined,
	changeName: () => undefined,
	setFetchedLanguages: () => undefined,
	setIDsLanguages: () => undefined,
	setDataForSubmit: () => undefined,
	changeTypeOfModalWindow: () => undefined,
	setTranslationTab: () => undefined,
	changeNameTranslation: () => undefined,
	resetFields: () => undefined,
	...createVideoCategoryInitialState,
});
